import { baseApi, ENDPOINTS } from '@/shared/api';

import type {
    GetPatternCandlesParams,
    PatternCandles,
} from '../model/types/pattern-candles';

const patternCandlesApi = baseApi
    .enhanceEndpoints({
        addTagTypes: ['PatternCandles'],
    })
    .injectEndpoints({
        endpoints: (build) => ({
            getPatternCandles: build.query<
                PatternCandles,
                GetPatternCandlesParams
            >({
                query: ({
                    /* eslint-disable @typescript-eslint/naming-convention */
                    master_idx,
                    subpattern_idx_list,
                    pattern_len,
                    /* eslint-enable @typescript-eslint/naming-convention */
                    timeframe,
                    ticker,
                }) => ({
                    url: ENDPOINTS.candles.getMasterSubPatternCandles,
                    method: 'POST',
                    body: {
                        master_idx,
                        subpattern_idx_list,
                        pattern_len,
                        timeframe,
                        ticker,
                    },
                }),
                providesTags: ['PatternCandles'],
            }),
        }),
    });

export const { useGetPatternCandlesQuery } = patternCandlesApi;

// Export the direct thunk for middleware use
export const getPatternCandlesThunk =
    patternCandlesApi.endpoints.getPatternCandles.initiate;

export const { getPatternCandles } = patternCandlesApi.endpoints;
